export default "__VITE_ASSET__0cd57a97__"